import {store} from "./store/store";
import Cookies from "js-cookie";

import Home from "./components/pages/Home";
import Blog from "./components/pages/blog/Blog";
import BlogDetail from "./components/pages/blog/Blog-detail.vue";
import Contacts from "./components/pages/Contacts";
import FAQ from "./components/pages/Faq";
import AboutUs from "./components/pages/about";
import Profile from "./components/pages/profile";

import CreateCvB1 from "./components/pages/cv/templates/basic/b-1/cv-action";
import CreateCvS1 from "./components/pages/cv/templates/standard/s-1/cv-action";
import CreateCvS2 from "./components/pages/cv/templates/standard/s-2/cv-action";
import CreateCvS3 from "./components/pages/cv/templates/standard/s-3/cv-action";
import CreateCvP1 from "./components/pages/cv/templates/pro/p-1/cv-action";
import CreateCvP2 from "./components/pages/cv/templates/pro/p-2/cv-action";
import CreateCvU1 from "./components/pages/cv/templates/ultra/u-1/cv-action";
import CreateCvU2 from "./components/pages/cv/templates/ultra/u-2/cv-action";

import CvShowB1 from "./components/pages/cv/templates/basic/b-1/Show";
import CvShowS1 from "./components/pages/cv/templates/standard/s-1/Show";
import CvShowS2 from "./components/pages/cv/templates/standard/s-2/Show";
import CvShowS3 from "./components/pages/cv/templates/standard/s-3/Show";
import CvShowP1 from "./components/pages/cv/templates/pro/p-1/Show";
import CvShowP2 from "./components/pages/cv/templates/pro/p-2/Show";
import CvShowU1 from "./components/pages/cv/templates/ultra/u-1/Show";
import CvShowU2 from "./components/pages/cv/templates/ultra/u-2/Show";

import error_404 from "./components/errors/404.vue";
import ComingSun from "./components/pages/ComingSun";
import PolicyPage from "./components/pages/PolicyPage";
import Map from "./components/pages/map/Map";

import beforeRoutesFunctions from './mixins/beforeRoutesFunctions';

const routes = [
  {
    path: "/:lang(ru|en|am)?",
    name: "home",
    component: Home
  },
  {
    path: "/:lang(ru|en|am)?/forgot",
    name: "homeForgot",
    component: Home
  },
  {
    path: "/:lang(ru|en|am)/lv",
    beforeEnter: beforeRoutesFunctions.redirectHome,
  },
  {
    path: "/:lang(ru|en|am)/tv/:pageName",
    beforeEnter: beforeRoutesFunctions.redirectTariff,
  },
  {
    path: "/:lang(ru|en|am)/profile",
    name: "profile",
    component: Profile,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/basic/b-1/create",
    name: "cv-create-b-1",
    component: CreateCvB1,
    beforeEnter: beforeRoutesFunctions.createCVEnter,
  },
  {
    path: "/:lang(ru|en|am)/cv/standard/s-1/create",
    name: "cv-create-s-1",
    component: CreateCvS1,
    beforeEnter: beforeRoutesFunctions.createCVEnter,
  },
  {
    path: "/:lang(ru|en|am)/cv/standard/s-2/create",
    name: "cv-create-s-2",
    component: CreateCvS2,
    beforeEnter: beforeRoutesFunctions.createCVEnter,
  },
  {
    path: "/:lang(ru|en|am)/cv/standard/s-3/create",
    name: "cv-create-s-3",
    component: CreateCvS3,
    beforeEnter: beforeRoutesFunctions.createCVEnter,
  },
  {
    path: "/:lang(ru|en|am)/cv/pro/p-1/create",
    name: "cv-create-p-1",
    component: CreateCvP1,
    beforeEnter: beforeRoutesFunctions.createCVEnter,
  },
  {
    path: "/:lang(ru|en|am)/cv/pro/p-2/create",
    name: "cv-create-p-2",
    component: CreateCvP2,
    beforeEnter: beforeRoutesFunctions.createCVEnter,
  },
  {
    path: "/:lang(ru|en|am)/cv/ultra/u-1/create",
    name: "cv-create-u-1",
    component: CreateCvU1,
    beforeEnter: beforeRoutesFunctions.createCVEnter,
  },
  {
    path: "/:lang(ru|en|am)/cv/ultra/u-2/create",
    name: "cv-create-u-2",
    component: CreateCvU2,
    beforeEnter: beforeRoutesFunctions.createCVEnter,
  },
  {
    path: "/:lang(ru|en|am)/cv/basic/b-1/edit/:cv",
    name: "cv-edit-b-1",
    component: CreateCvB1,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/standard/s-1/edit/:cv",
    name: "cv-edit-s-1",
    component: CreateCvS1,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/standard/s-2/edit/:cv",
    name: "cv-edit-s-2",
    component: CreateCvS2,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/standard/s-3/edit/:cv",
    name: "cv-edit-s-3",
    component: CreateCvS3,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/pro/p-1/edit/:cv",
    name: "cv-edit-p-1",
    component: CreateCvP1,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/pro/p-2/edit/:cv",
    name: "cv-edit-p-2",
    component: CreateCvP2,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/ultra/u-1/edit/:cv",
    name: "cv-edit-u-1",
    component: CreateCvU1,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/ultra/u-2/edit/:cv",
    name: "cv-edit-u-2",
    component: CreateCvU2,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/basic/b-1/show/:cv/:check_key?/:type?",
    name: "cv-show-b-1",
    component: CvShowB1,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/standard/s-1/show/:cv/:check_key?/:type?",
    name: "cv-show-s-1",
    component: CvShowS1,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/standard/s-2/show/:cv/:check_key?/:type?",
    name: "cv-show-s-2",
    component: CvShowS2,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/standard/s-3/show/:cv/:check_key?/:type?",
    name: "cv-show-s-3",
    component: CvShowS3,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/pro/p-1/show/:cv/:check_key?/:type?",
    name: "cv-show-p-1",
    component: CvShowP1,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/pro/p-2/show/:cv/:check_key?/:type?",
    name: "cv-show-p-2",
    component: CvShowP2,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },
  {
    path: "/:lang(ru|en|am)/cv/ultra/u-1/show/:cv/:check_key?/:type?",
    name: "cv-show-u-1",
    component: CvShowU1,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },

  {
    path: "/:lang(ru|en|am)/cv/ultra/u-2/show/:cv/:check_key?/:type?",
    name: "cv-show-u-2",
    component: CvShowU2,
    beforeEnter: beforeRoutesFunctions.ifAuthUser,
  },

  {
    path: "/:lang(ru|en|am)/blog",
    name: "blog",
    component: Blog,
  },
  {
    path: "/:lang(ru|en|am)/blog/:category",
    name: "blog.category",
    component: Blog,
  },
  {
    path: "/:lang(ru|en|am)/blog/:category/:post",
    name: "blog.category.post",
    component: BlogDetail,
  },
  {
    path: "/:lang(ru|en|am)/contacts",
    name: "contacts",
    component: Contacts,
  },
  {
    path: "/:lang(ru|en|am)/policy",
    name: "policy",
    component: PolicyPage,
  },
  {
    path: "/:lang(ru|en|am)/faq",
    name: "faq",
    component: FAQ,
  },
  {
    path: "/:lang(ru|en|am)/about-us",
    name: "about_us",
    component: AboutUs,
  },
  {
    path: "/:lang(ru|en|am)/vacancy",
    name: "vacancy",
    component: ComingSun,
  },
  {
    path: "/:lang(ru|en|am)/payment",
    name: "payment",
    component: Home,
  },
  {
    path: "/:lang(ru|en|am)/map",
    name: "map",
    component: Map,
  },
  {
    path: "/:lang(ru|en|am)/404",
    name: "error_404",
    component: error_404,
  },
  {
    path: "*",
    beforeEnter: function () {
       window.location.href = '/' + store.getters.locale + '/404'
    },
  }
];

export default routes;



// WEBPACK FOOTER //
// ./resources/js/routes.js